import React from 'react';
import { Feather } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';

import Text from '../../../components/text/Text';
import { Card } from '../../../design/components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { useTheme } from '../../../theme';
import { PRODUCT_CHANGE_WARNING_THRESHOLD } from '../../../utils/getStopProductChanges';
import { DRIVER_ROUTE } from '../driverRoutes';

const ProductChangesWarning = ({ docketId, productChangeCount }) => {
	const navigation = useNavigation();
	const styles = useThemedStyles(createStyles);
	const { theme: { ui: { colors } } } = useTheme();

	if (productChangeCount < PRODUCT_CHANGE_WARNING_THRESHOLD) {
		return null;
	}

	const label = `${productChangeCount} product ${productChangeCount === 1 ? 'change' : 'changes'} at this stop`;
	return (
		<Card
			tone="warning"
			style={styles.row}
			onPress={() => navigation.push(DRIVER_ROUTE.PRODUCT_CHANGES, { docketId })}
			accessibilityLabel={label}
			accessibilityHint="Shows the old and new products at this stop"
		>
			<Feather name="alert-triangle" size={20} color={colors.warning} />
			<Text style={styles.text}>{label}</Text>
			<Feather name="chevron-right" size={20} color={colors.warning} />
		</Card>
	);
};

const createStyles = ({ ui: { colors, space, type, touch } }) => ({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.sm,
		padding: space.md,
		minHeight: touch.min,
	},
	text: {
		...type.bodySmallStrong,
		color: colors.warning,
		flex: 1,
	},
});

export default ProductChangesWarning;
